import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common';

//import { Customers } from '../../Customers/models/customers';
import { CustomersService } from '../../Service/customers-service';
import { UdcsService } from '../../Service/udcs-service';
import { UppercaseDirective } from '../../util/uppercase'; // <-- 1. Importa el archivo
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { map, catchError, of, Observable } from 'rxjs';
import { Router, RouterLink } from '@angular/router';

import { ToastService } from '../../Service/toast-service'; 
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-customer-add',
  standalone: true, // Habilitado por defecto en arquitecturas modernas
  imports: [CommonModule, 
            ReactiveFormsModule,
            UppercaseDirective,
            RouterLink
  ],
  templateUrl: './customer-add.html',
  styleUrl: './customer-add.css',
})
export class CustomerAdd implements OnInit {
  customerForm!: FormGroup;

  // Catálogos estáticos para mantener la consistencia en menús desplegables
  //tiposPersona: string[] = ['FISICA', 'MORAL'];
  // Cambia la definición de tu lista en la clase por esta:
  tiposPersona: { codigo: string; descripcion: string; tipo: 'FISICA' | 'MORAL' }[] = [
  // 👤 PERSONAS FÍSICAS (RFC de 13 dígitos)
  { codigo: '605', descripcion: 'FISICA - Sueldos y Salarios e Ingresos Asimilados', tipo: 'FISICA' },
  { codigo: '606', descripcion: 'FISICA - Arrendamiento', tipo: 'FISICA' },
  { codigo: '612', descripcion: 'FISICA - Actividades Empresariales y Profesionales', tipo: 'FISICA' },
  { codigo: '625', descripcion: 'FISICA - Actividades Empresariales con ingresos por Plataformas Tecnológicas', tipo: 'FISICA' },
  { codigo: '626', descripcion: 'FISICA - Régimen Simplificado de Confianza (RESICO)', tipo: 'FISICA' },
  { codigo: '616', descripcion: 'FISICA - Sin obligaciones fiscales (Público en General / Extranjero)', tipo: 'FISICA' },

  // 🏢 PERSONAS MORALES (RFC de 12 dígitos)
  { codigo: '601', descripcion: 'MORAL - General de Ley Personas Morales', tipo: 'MORAL' },
  { codigo: '603', descripcion: 'MORAL - Personas Morales con Fines no Lucrativos', tipo: 'MORAL' },
  { codigo: '620', descripcion: 'MORAL - Sociedad Cooperativa de Producción', tipo: 'MORAL' },
  { codigo: '623', descripcion: 'MORAL - Régimen Opcional para Grupos de Sociedades', tipo: 'MORAL' },
  { codigo: '624', descripcion: 'MORAL - Coordinados (Transporte)', tipo: 'MORAL' }
];  

  estatusAprobacion: string[] = ['PENDIENTE', 'APROBADO', 'RECHAZADO'];
  metodosPago: string[] = ['PUE', 'PPD'];
  formasPago: string[] = ['01', '03', '04', '28', '99']; // Efectivo, Transferencia, Tarjeta, etc.
  tiposMoneda: string[] = ['MXN', 'USD', 'EUR'];

  paises: any[] = [];
  estados: any[] = [];
  mostrarDesplegableEstado: boolean = true; // Controla la visibilidad del Select vs Input

  // Arreglo dinámico que se pintará en el HTML
  girosEconomicos: any[] = [];

  altaRapida: boolean = false;

  constructor(
    private customerService: CustomersService,
    private udcsService: UdcsService, // 2. Inyectamos el servicio aquí
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    public toastService: ToastService,
    private router: Router // 🚀 INYECTADO: Motor nativo de redirección de rutas
  ){}

  ngOnInit(): void {
    this.initForm();
    this.cargarGirosEconomicosUDC(); // 4. Disparamos la carga al arrancar la pantalla
    this.cargarConfiguracionGeografica(); // 🌟 VITAL: Si esta línea no está puesta, el arreglo 'paises' jamás se llenará
    this.escucharCambioPais(); // Mantiene tus alertas de teléfonos activas
    this.activarRecordatorioEstado(); // 🌟 NUEVO: Escuchador inteligente de la sección de Domicilio
    this.escucharErroresCorreo(); // 🌟 NUEVO: Escucha si el correo se duplica para lanzar el Toast de inmediato
    this.escucharErroresRfc();
  }

  private escucharErroresCorreo(): void {
    const emailControl = this.customerForm.get('email');
    
    if (emailControl) {
      // Escuchamos el valor del texto en lugar del estatus global
      emailControl.valueChanges.pipe(
        debounceTime(600),        // Espera 600 milisegundos después de que el usuario deja de teclear
        distinctUntilChanged()    // Solo dispara si el texto realmente cambió
      ).subscribe(() => {
        
        // Forzamos a Angular a revisar las validaciones después del retraso de escritura
        if (emailControl.hasError('correoDuplicado')) {
          
          // Disparamos la alerta flotante roja
          // 1. Disparamos la alerta flotante (Toast)
          this.toastService.showDanger(
            'Bloqueo por Duplicidad',
            `El correo [${emailControl.value.toUpperCase()}] ya pertenece a otro cliente registrado en MySQL.`
          );
          
          // 2. Forzamos a que el campo se marque como tocado para asegurar que se pinte de rojo en el HTML
          emailControl.markAsTouched();

          // ¡CRÍTICO! Avisamos a la interfaz de Angular que pinte el Toast de inmediato
          this.cdr.detectChanges(); 
        }
      });
    }
  }


  private activarRecordatorioEstado(): void {
    // Monitoreamos si el usuario toca o escribe en la Calle, Colonia o Código Postal
    const camposDisparadores = ['calleNumero', 'colonia', 'codigoPostal'];
    
    camposDisparadores.forEach(nombreCampo => {
      const control = this.customerForm.get(nombreCampo);
      
      if (control) {
        // Escuchamos de forma reactiva cada vez que el estado del campo cambia (ej. de pristine a touched)
        control.statusChanges.subscribe(() => {
          // Si el usuario ya interactuó con alguno de estos campos y estamos en Carga Detallada
          if ((control.touched || control.dirty) && !this.altaRapida) {
            const estadoControl = this.customerForm.get('estado');
            
            // Si el estado sigue vacío, lo pintamos de rojo inmediatamente como recordatorio
            if (estadoControl && (!estadoControl.value || estadoControl.value === '')) {
              estadoControl.markAsTouched();
              this.cdr.detectChanges(); // Fuerza la actualización visual
            }
          }
        });
      }
    });
  }

  private escucharCambioPais(): void {
    const paisControl = this.customerForm.get('country');
    
    // Recuperamos las referencias de los tres controles telefónicos del formulario
    const telCentral = this.customerForm.get('telefonoDF');
    const telCxC = this.customerForm.get('telefonoContactoCxC');
    const telPedidos = this.customerForm.get('telefonoContactoPedidos');

    if (paisControl) {
      // Ejecución inicial segura con el valor por defecto ('MEXICO') al cargar la pantalla
      this.ajustarValidadorTelefono(paisControl.value, telCentral);
      this.ajustarValidadorTelefono(paisControl.value, telCxC);
      this.ajustarValidadorTelefono(paisControl.value, telPedidos);

      // Escucha reactiva si el operador cambia el país en caliente
      paisControl.valueChanges.subscribe(nuevoPais => {
        this.ajustarValidadorTelefono(nuevoPais, telCentral);
        this.ajustarValidadorTelefono(nuevoPais, telCxC);
        this.ajustarValidadorTelefono(nuevoPais, telPedidos);
      });
    }
  }

  private ajustarValidadorTelefono(pais: string, controlTelefono: any): void {
    // Si el control no existe o no se ha inicializado, salimos para prevenir errores de consola
    if (!controlTelefono) return;

    // 💡 MEJORA JDE: Valida tanto 'MEXICO' como el código ISO 'MX' de tus catálogos
    if (pais && (pais.toUpperCase().trim() === 'MEXICO' || pais.toUpperCase().trim() === 'MX')) {
      // Fuerza 10 dígitos exactos si el destino comercial es nacional
      controlTelefono.setValidators([
        Validators.pattern('^[0-9]{10}$')
      ]);
    } else {
      // Libera la longitud para números internacionales (como USA de 11 o 12 dígitos con código de área)
      controlTelefono.setValidators([
        Validators.pattern('^[0-9]*$')
      ]);
    }
    // Fuerza a Angular a recalcular inmediatamente el estado de validez del input modificado
    controlTelefono.updateValueAndValidity();
  }

  // 3. Método operativo para consumir el API de forma segura
  cargarGirosEconomicosUDC(): void {
    this.udcsService.getGirosEconomicos().subscribe({
      next: (data) => {
        this.girosEconomicos = data; // Almacena [{ keyRef: 'PRI_01', description: '...' }]
        this.cdr.detectChanges();    // Fuerza el renderizado visual en el HTML
      },
      error: (err) => console.error('Error al obtener giros económicos desde la tabla UDC', err)
    });
  }

  private initForm(): void {
    this.customerForm = this.fb.group({
      // =========================================================================
      // CONTROL CORE: LLAVE NATURAL REFACTORIZADA (8 DÍGITOS ESTILO JDE)
      // =========================================================================
      an8: [0, [Validators.min(0), Validators.max(4294967295)]],
      // =========================================================================
      // CONTROLES OPERATIVOS Y DE APROBACIÓN
      // =========================================================================

      // Campos Core de Negocio (Siempre Obligatorios)
      name: ['', [Validators.required, Validators.maxLength(255)]],
      approvalStatus: ['PENDIENTE'], // 💡 MEJORA: Quitamos el required para evitar trabas tras el reset
      fisicaMoral: ['605', [Validators.required]], // FISICA

      email: [
        '', 
        [Validators.required, Validators.email, Validators.maxLength(150)], 
        [this.validarEmailUnico.bind(this)] 
      ],

      // Campos que se volverán opcionales en Alta Rápida
      rfc: [
        '', 
        [Validators.required, Validators.pattern('^[A-Z&Ññ]{3,4}[0-9]{6}[A-Z0-9]{3}$')], // ('^[A-Z&Ññ]{3,4}[0-9]{6}[A-Z0-9]{3}$')
        [this.validarRfcUnico.bind(this)]
      ],
      calleNumero: ['', [Validators.required]],
      colonia: ['', [Validators.required]],
      codigoPostal: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]],
      delegacionMnicipio: ['', [Validators.required]],
      estado: ['', [Validators.required]],
      country: ['MX', [Validators.required]],
      ciudad: ['', [Validators.required]],

      compradorAsignado: [''],

      giroEmpresa: [''],
      webSite: [''],
      telefonoDF: [''],
      
      // Contactos de Cobranza (CxC)
      nombreContactoCxC: [''],
      emailContactoCxC: [''],
      telefonoContactoCxC: [''],

    // Contactos de Compras
      nombreContactoCompras: [''],
      emailCompras: [''],
      telefonoCompras: [''],      
      
      // Contactos de Cuentas por Pagar (CxP)
      emailCxP01: [''], nombreContactoCxP01: [''], telefonoCxP01: [''],
      
      // Contactos adicionales
      nombreContactoPedidos: [''], emailContactoPedidos: [''], telefonoContactoPedidos: [''],
      nombreContactoVentas: [''], emailContactoVentas: [''], telefonoContactoVentas: [''],
      
      observaciones: [''],
      batchNumber: [''],

      automaticEmail: [''],
      currencyCode: ['MXN'],
      
      outSourcing: [false],
      outSourcingAccept: [false],
      outSourcingMonthlyAccept: [false],
      outSourcingBimonthlyAccept: [false],
      outSourcingQuarterlyAccept: [false],
      supplierWithoutOC: [false],
      supplierWithOC: [false],
      outSourcingRecordDate: [null]
    }, { 
      validators: [this.validadorRfcRegimen.bind(this)] // 👈 AGREGADO: Vincula el validador de consistencia SAT
    });
  }

  // 🌟 NUEVO: Función validadora asíncrona
  private validarEmailUnico(control: AbstractControl): Observable<ValidationErrors | null> {
    if (!control.value || control.value.trim() === '') {
      return of(null); // Si está vacío, la validación obligatoria tradicional se encarga
    }

    const emailLimpio = control.value.trim().toUpperCase(); 

    // Ejecuta la consulta al backend enviando el correo actual
    return this.customerService.verificarCorreoDuplicado(emailLimpio).pipe(
      map((existe: boolean) => {
        // Si la API responde true, le clavamos el error personalizado 'correoDuplicado' al campo
        return existe ? { correoDuplicado: true } : null;
      }),
      catchError(() => of(null)) // Protección si la API se cae, permite continuar para no trabar la pantalla
    );
  }

  toggleAltaRapida(event: any): void {
    // 1. Guardamos si el switch está encendido (true) o apagado (false)
    this.altaRapida = event.target.checked;
    
    // 🌟 MEJORA UX: Si el usuario cambia de modo, limpiamos inmediatamente cualquier alerta flotante
    // vieja que se haya quedado atrapada en la pantalla para no confundir al operador
    if (this.toastService) {
      this.toastService.toasts = [];
    }

    // 2. Definimos los campos de texto que se vuelven opcionales en Alta Rápida
    const camposFlexibles = [
      'rfc', 'calleNumero', 'colonia', // 'razonSocial', 
      'codigoPostal', 'delegacionMnicipio', 'estado', 'ciudad'
    ];

    // 3. Recorremos cada campo flexible para poner o quitar sus validaciones obligatorias
    camposFlexibles.forEach(campo => {
      const control = this.customerForm.get(campo);
      if (!control) return;

      if (this.altaRapida) {
        // Si activan Alta Rápida, les quitamos la obligatoriedad a estos campos
        control.clearValidators();
      } else {
        // Si desactivan Alta Rápida (vuelven a modo Detallado), restauramos sus reglas estrictas
        if (campo === 'rfc') {
          control.setValidators([Validators.required, Validators.pattern('^[A-Z&Ññ]{3,4}[0-9]{6}[A-Z0-9]{3}$')]);
        } else if (campo === 'codigoPostal') {
          control.setValidators([Validators.required, Validators.pattern('^[0-9]{5}$')]);
        } else {
          control.setValidators([Validators.required]);
        }
      }
      // Le avisamos a Angular que recalcule el estado del campo modificado
      control.updateValueAndValidity({ emitEvent: false });
    });

    // =========================================================================
    // 4. CONTROL EXCLUSIVO PARA EL CORREO ELECTRÓNICO (EMAIL)
    // =========================================================================
    const emailControl = this.customerForm.get('email');
    
    if (emailControl) {

      // 🌟 REGLA DE ORO: En AMBOS modos (Rápido y Detallado) el correo exige
      // ser obligatorio, tener formato válido y consultar duplicados en Java.
      emailControl.setValidators([Validators.required, Validators.email, Validators.maxLength(150)]);
      emailControl.setAsyncValidators([this.validarEmailUnico.bind(this)]); 

      if (this.altaRapida && (!emailControl.value || emailControl.value.trim() === '')) {
        emailControl.markAsUntouched();                
      } 
      emailControl.updateValueAndValidity({ emitEvent: false });

      if (emailControl.value && emailControl.value.trim() !== '') {
        emailControl.markAsTouched(); // Asegura que permanezca la casilla roja
        this.validarEmailUnico(emailControl).subscribe(errores => {
          if (errores && errores['correoDuplicado']) {
            emailControl.setErrors({ correoDuplicado: true });
            this.cdr.detectChanges(); // Fuerza a la pantalla a redibujar el error estático
          }
        });
      }
    }

	  // =========================================================================
    // 🎛️ CONTROL EXCLUSIVO PARA EL RFC (PERMISIVIDAD FISCAL UNIVERSAL)
    // SOLUCIÓN: El RFC genérico es legal tanto en modo rápido como detallado.
    // Removemos el blanqueo automático para permitir altas detalladas temporales.
    // =========================================================================
    const rfcControl = this.customerForm.get('rfc');
    if (rfcControl) {
      // El validador asíncrono se queda fijo en ambos flujos para interceptar duplicados reales
      rfcControl.setAsyncValidators([this.validarRfcUnico.bind(this)]);

      if (this.altaRapida) {
        // En modo rápido, SI el campo está vacío, le ayudamos inyectando el genérico
        if (!rfcControl.value || rfcControl.value.trim() === '') {
          // Asigna el RFC Genérico del SAT por defecto en modo express
          rfcControl.setValue('XAXX010101000', { emitEvent: false });
        }
        
      } else {
        // 🚀 LA TUERCA DE ORO UX:
        // Al regresar a modo detallado, ya NO borramos nada. Si tiene el genérico, 
        // lo dejamos vivir de forma legal en la pantalla para que el operador pueda 
        // capturar el domicilio completo y avanzar con el alta del carro.

        // Si regresan a Carga Detallada y tiene el genérico por defecto, limpiamos para captura libre
        if (rfcControl.value === 'XAXX010101000') {
          rfcControl.setValue('', { emitEvent: false });
          rfcControl.markAsUntouched();
        } else if (rfcControl.value && rfcControl.value.trim() !== '') {
          rfcControl.markAsTouched();
        }
      }
      
      // Indicamos a Angular que recalcule el estado interno de la casilla
      rfcControl.updateValueAndValidity();
      this.cdr.detectChanges();
    }

  }

  /**
   * 💡 MÉTODO DE MEJORA UX: Restaura de forma contundente las reglas de validación
   * obligatorias para el modo detallado, evitando que el formulario quede huérfano de reglas tras un reset.
   */
  private restaurarValidadoresCargaDetallada(): void {
    const camposEstrictos = [
      'rfc', 'calleNumero', 'colonia', // 'razonSocial', 
      'codigoPostal', 'delegacionMnicipio', 'estado', 'country', 'ciudad'
    ];

    camposEstrictos.forEach(campo => {
      const control = this.customerForm.get(campo);
      if (!control) return;

      // Aplicamos de vuelta las expresiones regulares y la obligatoriedad originales
      if (campo === 'rfc') {
        control.setValidators([Validators.required, Validators.pattern('^[A-Z&Ññ]{3,4}[0-9]{6}[A-Z0-9]{3}$')]);
      } else if (campo === 'codigoPostal') {
        control.setValidators([Validators.required, Validators.pattern('^[0-9]{5}$')]);
      } else {
        control.setValidators([Validators.required]);
      }
      
      // Forzamos a Angular a recalcular el estado interno de validez para cada casilla
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  // Captura la estructura de fecha y hora local sincronizada con tu API
  getFechaActual(): string {
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const dia = String(hoy.getDate()).padStart(2, '0');
    const horas = String(hoy.getHours()).padStart(2, '0');
    const minutos = String(hoy.getMinutes()).padStart(2, '0');
    
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  }
  
addCustomer(): void {

    if (this.customerForm.invalid) {
      // 1. Esto enciende en rojo INSTANTÁNEAMENTE todos los campos obligatorios vacíos (incluido el Estado)
      this.customerForm.markAllAsTouched(); 
      
      // 2. Buscamos el primer campo con error en la pantalla
      const primerError = document.querySelector('.is-invalid');
      if (primerError) {
        // Hace un scroll suave hacia el campo que causó el bloqueo
        primerError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      console.warn('El formulario de clientes contiene errores de validación. Campos iluminados.');
      return;
    }

    // Clonamos el valor actual del formulario
    //const customer: Customers = { ...this.customerForm.value };

    // 🚀 SOLUCIÓN CRÍTICA: Cambiamos 'const customer: Customers' por tipado libre 'any'
    // Esto disuelve de golpe los errores ts(2339) y ts(2367) al saltarse la restricción de la interfaz recortada
    const customer: any = { ...this.customerForm.value };

    // Asignamos el código numérico directamente al campo que espera la base de datos
    customer.tax2 = customer.fisicaMoral; 
    delete customer.fisicaMoral;
    //customer.crdc = customer.currencyCode;

    //customer.automaticEmail = customer.email;

    // =========================================================================
    // 🚀 MEJORA: PURIFICACIÓN TRANSACCIONAL A MAYÚSCULAS (CERO TRABAS DE CURSOR)
    // =========================================================================
    // Recorremos de forma masiva cada propiedad del clon antes de despacharlo.
    // Si el valor es una cadena de texto (String), le aplicamos mayúsculas y quitamos espacios colgados.
    Object.keys(customer).forEach(key => {
      const valor = (customer as any)[key];
      if (typeof valor === 'string' && valor.trim() !== '') {
        (customer as any)[key] = valor.trim().toUpperCase();
      }
    });    

    // Relleno seguro preventivo para evitar campos de texto vacíos en la base de datos
    if (this.altaRapida) {
      //if (!customer.razonSocial) customer.razonSocial = customer.name;
      if (!customer.rfc) customer.rfc = 'XAXX010101000'; // RFC genérico mexicano de respaldo
    }

    console.log('Despachando Cliente Reactivo Saneado y en Mayúsculas:', customer);
    
    // Aquí se ejecuta tu lógica actual que ya invoca de forma segura al creador de AN8
    this.customerService.createCustomer(customer).subscribe({
      next: (res: any) => {
        console.log('Cliente corporativo guardado con éxito en el ecosistema', res);

        this.router.navigate(['/customers'], {
          state: {
            mostrarAlertaExito: true,
            mensajeToast: `El cliente corporativo [${customer.name}] ha sido registrado con éxito en el Address Book.`
          }
        });
      },
      error: (err) => {
        console.error('Error fatal al persistir el cliente corporativo', err);   
        // También mapeamos errores generales del servidor aquí
        this.toastService.showDanger('Error de Persistencia', err.error || 'El servidor rechazó el alta corporativa.');
      }
    });
  }


  // Agrega este método en tu componente .ts para bloquear letras al escribir
  soloNumeros(event: KeyboardEvent): boolean {
    const charCode = event.key;
    // Si la tecla no es un número del 0 al 9, cancela la pulsación
    if (!/^[0-9]$/.test(charCode)) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  // Llama a este único método dentro de tu ngOnInit()
  cargarConfiguracionGeografica(): void {
    this.udcsService.getPaisesMundo().subscribe({
      next: (data) => {
        // 1. Almacenamos el catálogo que viene del servidor
        this.paises = data; 
        console.log('>>> Catálogo de Países cargado con éxito:', this.paises);

        // 2. Inicializamos por defecto en México asignando su código ISO 'MX'
        this.customerForm.get('country')?.setValue('MX');
        this.mostrarDesplegableEstado = true;
        this.cargarEstadosCascada('MX');
        
        this.cdr.detectChanges(); // Fuerza a Angular a pintar las opciones en el select
      },
      error: (err) => console.error('Error al recuperar países:', err)
    });
  }

  
  // Escucha el evento (change) directo del HTML
  onPaisCambiado(event: any): void {
    const codigoPais = event.target.value;
    const estadoControl = this.customerForm.get('estado');

    if (codigoPais === 'MX' || codigoPais === 'US') {
      this.mostrarDesplegableEstado = true;
      this.cargarEstadosCascada(codigoPais);
    } else {
      this.mostrarDesplegableEstado = false;
      this.estados = [];
      estadoControl?.setValue(''); // Libera para captura manual de texto libre
    }
    this.cdr.detectChanges();
  }

  private cargarEstadosCascada(codigoPais: string): void {
    this.udcsService.getEstadosPorPais(codigoPais).subscribe({
      next: (data) => {
        this.estados = data;
        this.customerForm.get('estado')?.setValue(''); // Limpia el estado del país anterior
        this.cdr.detectChanges();
      },
      error: (err) => console.error('Error al recuperar estados en cascada:', err)
    });
  }

  private validarRfcUnico(control: AbstractControl): Observable<ValidationErrors | null> {
    if (!control.value || control.value.trim() === '') return of(null);
    const rfcLimpio = control.value.trim().toUpperCase();
    if (rfcLimpio === 'XAXX010101000') return of(null);

    return this.customerService.verificarRfcDuplicado(rfcLimpio).pipe(
      map((existe: boolean) => existe ? { rfcDuplicado: true } : null),
      catchError(() => of(null)) // Protección si la red parpadea
    );
  }

  private escucharErroresRfc(): void {
    const rfcControl = this.customerForm.get('rfc');
    if (rfcControl) {
      rfcControl.valueChanges.pipe(
        debounceTime(600),
        distinctUntilChanged((prev, curr) => prev.rfc === curr.rfc && prev.fisicaMoral === curr.fisicaMoral)
      ).subscribe(() => {
        // 🚀 ADUANA MULTI-TENANT: Si tiene el error de duplicidad y el valor NO es el genérico,
        // levantamos el Toast rojo inmediatamente, sin importar si está en carga rápida o detallada.

        // Alerta A: Bloqueo por duplicidad real en la base de datos MySQL
        if (rfcControl.hasError('rfcDuplicado') && rfcControl.value?.toUpperCase() !== 'XAXX010101000') {
          this.toastService.showDanger(
            'Bloqueo por Duplicidad Fiscal',
            `El RFC [${rfcControl.value.toUpperCase()}] ya pertenece a otro cliente registrado en esta compañía.`
          );
          rfcControl.markAsTouched();
          this.cdr.detectChanges(); 
        }

        // Alerta B: Nueva validación de incongruencia entre longitud del RFC y régimen SAT
        if (rfcControl.hasError('rfcRegimenInvalido')) {
          const mensajeCustom = rfcControl.getError('rfcRegimenInvalido');
          this.toastService.showDanger(
            'Incongruencia Fiscal SAT',
            `⚠️ ${mensajeCustom}`
          );
          rfcControl.markAsTouched();
          this.cdr.detectChanges();
        }        
      });
    }
  }


  private validadorRfcRegimen(group: AbstractControl): ValidationErrors | null {
    // 1. Si está encendida la Alta Rápida, omitimos por completo las alertas de congruencia
    if (this.altaRapida) return null;

    const rfcControl = group.get('rfc');
    const regimenControl = group.get('fisicaMoral');

    if (!rfcControl || !regimenControl || !rfcControl.value) return null;

    const rfcLimpio = rfcControl.value.toString().trim().toUpperCase();
    const longitudRfc = rfcLimpio.length;
    
    // 2. Si es el RFC Genérico de público en general, no se disparan errores de longitud
    if (rfcLimpio === 'XAXX010101000') return null;

    const regimenInfo = this.tiposPersona.find(r => r.codigo === regimenControl.value);
    if (!regimenInfo) return null;

    let error: ValidationErrors | null = null;

    // ❌ Incongruencia: RFC de Empresa (12 caracteres) con Régimen de Persona Física (605, 612)
    if (longitudRfc === 12 && regimenInfo.tipo === 'FISICA') {
      error = { rfcRegimenInvalido: 'Persona Moral no puede vincularse a un régimen de Persona Física.' };
    }
    // ❌ Incongruencia: RFC de Persona (13 caracteres) con Régimen de Persona Moral (601)
    else if (longitudRfc === 13 && regimenInfo.tipo === 'MORAL') {
      error = { rfcRegimenInvalido: 'Persona Física no puede vincularse a un régimen de Personas Morales.' };
    }
    // ❌ Estructura incorrecta general
    else if (longitudRfc > 0 && longitudRfc !== 12 && longitudRfc !== 13) {
      error = { rfcRegimenInvalido: 'Estructura inválida. El RFC en México debe tener 12 o 13 caracteres.' };
    }

    // 🔴 Si hay error, se lo aplicamos a AMBOS campos para que Bootstrap los pinte en rojo
    // Inyectamos el error directamente en el input del RFC para encender las clases invalid-feedback del HTML
    if (error) {
      rfcControl.setErrors({ ...rfcControl.errors, ...error });
      regimenControl.setErrors({ ...regimenControl.errors, ...error });
    } else {
      // 🟢 Si ya es correcto, limpiamos el error de ambos de forma segura
      if (rfcControl.errors) {
        const { rfcRegimenInvalido, ...rest } = rfcControl.errors;
        rfcControl.setErrors(Object.keys(rest).length ? rest : null);
      }
      if (regimenControl.errors) {
        const { rfcRegimenInvalido, ...rest } = regimenControl.errors;
        regimenControl.setErrors(Object.keys(rest).length ? rest : null);
      }
    }

    return error;
  }

}